var codeblock_default = {
  "blockStyleSpacing": "_2TdX0",
  "codeBlock": "vKlJL _2TdX0",
  "renderedInTable": "Or01S"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
